import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

interface MostrarOptions {
  showCancelButton?: boolean;
  confirmButtonText?: string;
  mostrarConfirmButton?: boolean;
  cancelButtonText?: string;
}
interface MensajeAel2Options {
  ejecutarAccionAlConfirmar?: boolean;
  accionConfirmacion?: () => void;
  onAfter?: () => void; // p0
  width?: string;
}
interface MensajeAel3Options {
  showCancelButton?: boolean;
  confirmButtonText?: string;
  mostrarConfirmButton?: boolean;
  ejecutarAccionAlConfirmar?: boolean;
  accionConfirmacion?: () => void;
  accionCancelacion?: () => void;
  onAfter?: () => void; // p0
  width?: string;
  cancelButtonText?: string;
}
export interface AdvertenciaCredencialesOptions {
  segundosContador?: number;
  confirmButtonText?: string;
  mensajeConfirmacion: string;
  width?: string;
  accionConfirmacion?: () => void | Promise<void>;
  onAfter?: () => void;
}
export enum EnumIconos {
  logo = "assets/images/logo/Logo_AEL.svg",
  exito = "assets/images/svg/action_true.svg",
  error = "assets/images/svg/action_false.svg",
  info = "assets/images/svg/action_info.svg",
  warning = "assets/images/svg/action_warning.svg",
  cargador = `assets/apl-afiliacion/gif/cargador.gif`,
  time = `assets/apl-afiliacion/imagenes/time.png`,
}

@Injectable({
  providedIn: "root",
})
export class UtilPopupService {
  /**
   * Getter that returns a configured Swal instance.
   */
  get swal(): typeof Swal {
    return Swal.mixin({
      allowOutsideClick: false,
      allowEscapeKey: false,
      cancelButtonText: "No",
      confirmButtonText: "Si",
      showCancelButton: true,
      showCloseButton: true,
      customClass: {
        popup: "text-black min-w-1/3",
        title: "mat-headline-3 font-normal text-black",
        actions: "flex flex-col flex-auto w-full px-8",
        confirmButton: "w-full bg-primary text-white",
        cancelButton: "w-full bg-primary text-white",
      },
    });
  }

  /**
   * Method to display a message on the screen using sweetalert2.
   * @param mensaje Message text, can be HTML.
   * @param tipo Message type 'warning' | 'error' | 'success' | 'info' | 'question'.
   * @param titulo Message title.
   * @param mostrarConfirmacion Indicates whether to display the confirmation button.
   * @param confirmButtonText Indicated confirm button text
   * @returns typeof @Swal
   */

  mostrarMensaje(
    mensaje: string,
    tipo?: keyof typeof EnumIconos,
    titulo: string = "",
    mostrarConfirmacion: boolean = true,
    confirmButtonText: string = "Continuar",
    logo: EnumIconos = EnumIconos.logo,
  ) {
    return this.swal.fire({
      html: `
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
        <div style="width: 150px; height: 84px;">
          <img style="width: 150px; height: 84px;" src="${logo}" />
        </div>

        <div style="display: grid; grid-template-columns: 1fr 3fr; justify-items: center; align-items: center; gap: 15px">
          <div style="width: 52px; height: 52px;">
            <img style="width: 52px; height: 52px;" src="${EnumIconos[tipo]}" />
          </div>

          <div style="display: flex; flex-direction: column; gap: 10px; align-items: start">
            <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
              ${titulo}
            </div>

            <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262">
              ${mensaje}
            </div>
          </div>
        </div>
      </div>  
    `,
      width: "484px",
      background: "#FFFFFF",
      showCancelButton: mostrarConfirmacion,
      showCloseButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonText: confirmButtonText,
      showConfirmButton: true,
      customClass: {
        confirmButton: "button-primary-swal",
        cancelButton: "button-secondary-swal",
      },
    });
  }

  mostrarMensajeAelAprendiz(
    titulo: string = "",
    mensaje: string = "",
    icono: EnumIconos = EnumIconos.exito,
    logo: EnumIconos = EnumIconos.logo,
    options: MostrarOptions = {},
  ) {
    const {
      showCancelButton = true,
      confirmButtonText = "Continuar",
      mostrarConfirmButton = true,
      cancelButtonText = "Volver",
    } = options;

    return this.swal.fire({
      html: `
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
          <div style="width: 150px; height: 84px;">
              <img style="width: 150px; height: 84px;" src="${logo}" />
          </div>

          <div style="display: grid; grid-template-columns: 1fr 3fr; justify-items: center; align-items: center; gap: 15px">
              <div style="width: 52px; height: 52px;">
                  <img style="width: 52px; height: 52px;" src="${icono}" />
              </div>

              <div style="display: flex; flex-direction: column; gap: 10px; align-items: start">
                  <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
                      ${titulo}
                  </div>

                  <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262">
                      ${mensaje}
                  </div>
              </div>
          </div>
      </div>
    `,
      width: "484px",
      background: "#FFFFFF",
      showCancelButton,
      showCloseButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonText,
      cancelButtonText,
      showConfirmButton: mostrarConfirmButton,
      customClass: {
        confirmButton: "button-primary-swal",
        cancelButton: "button-secondary-swal",
      },
    });
  }

  mostrarMensajeAel(
    titulo: string = "",
    mensaje: string = "",
    icono: EnumIconos = EnumIconos.exito,
    logo: EnumIconos = EnumIconos.logo,
    options: MostrarOptions = {},
  ) {
    const {
      showCancelButton = false,
      confirmButtonText = "Aceptar",
      mostrarConfirmButton = true,
      cancelButtonText = "Volver",
    } = options;

    return this.swal.fire({
      html: `
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
          <div style="width: 150px; height: 84px;">
              <img style="width: 150px; height: 84px;" src="${logo}" />
          </div>

          <div style="display: grid; grid-template-columns: 1fr 3fr; justify-items: center; align-items: center; gap: 15px; margin-bottom: 10px">
              <div style="width: 52px; height: 52px;">
                  <img style="width: 52px; height: 52px;" src="${icono}" />
              </div>

              <div style="display: flex; flex-direction: column; gap: 10px; align-items: start">
                  <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
                      ${titulo}
                  </div>

                  <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262">
                      ${mensaje}
                  </div>
              </div>
          </div>
      </div>
    `,
      width: "484px",
      background: "#FFFFFF",
      showCancelButton,
      showCloseButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonText,
      cancelButtonText,
      showConfirmButton: mostrarConfirmButton,
      customClass: {
        confirmButton: "button-primary-swal",
        cancelButton: "button-secondary-swal",
      },
    });
  }

  mostrarMensajeAelConDescarga(
    titulo: string = "",
    mensaje: string = "",
    icono: EnumIconos = EnumIconos.error,
    logo: EnumIconos = EnumIconos.logo,
    archivoBase64?: string,
    nombreArchivo: string = "Errores_Carga.xlsx",
  ) {
    return this.swal.fire({
      html: `
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">

        <div style="width: 150px; height: 84px;">
          <img style="width: 150px; height: 84px;" src="${logo}" />
        </div>

        <div style="display: grid; grid-template-columns: 1fr 3fr; justify-items: center; align-items: center; gap: 15px; margin-bottom: 10px">

          <div style="width: 52px; height: 52px;">
            <img style="width: 52px; height: 52px;" src="${icono}" />
          </div>

          <div style="display: flex; flex-direction: column; gap: 10px; align-items: start">
            <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
              ${titulo}
            </div>

            <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262">
              ${mensaje}
            </div>
          </div>
        </div>

      </div>
    `,
      width: "484px",
      background: "#FFFFFF",
      showCancelButton: false,
      showCloseButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonText: "Descargar",
      showConfirmButton: true,
      customClass: {
        confirmButton: "button-primary-swal",
      },

      preConfirm: () => {
        if (archivoBase64) {
          this.downloadBase64File(
            archivoBase64,
            nombreArchivo,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          );
        }
      },
    });
  }

  private downloadBase64File(
    base64Input: string,
    filename: string,
    mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ): void {
    if (!base64Input) return;

    // Soporta "data:...;base64,XXXX"
    const [meta, dataPart] = base64Input.includes("base64,")
      ? base64Input.split("base64,")
      : ["", base64Input];

    const cleanBase64 = (dataPart ?? "").trim();

    // Si trae mime en el prefix, úsalo
    const inferredMime =
      meta.startsWith("data:") && meta.includes(";")
        ? meta.substring(5, meta.indexOf(";"))
        : mimeType;

    const byteChars = atob(cleanBase64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: inferredMime });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  }

  async mostrarMensajeAel2(
    titulo: string = "",
    titulo2: string = "",
    mensaje: string = "",
    icono: EnumIconos = EnumIconos.exito,
    logo: EnumIconos = EnumIconos.logo,
    options: MensajeAel2Options = {},
  ) {
    const {
      ejecutarAccionAlConfirmar = false,
      accionConfirmacion,
      onAfter,
      width = "484px",
    } = options;

    return this.swal
      .fire({
        html: `
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
            <div style="width: 150px; height: 84px;">
                <img style="width: 150px; height: 84px;" src="${logo}" />
            </div>

            <div style="display: flex; justify-items: center; align-items: center; gap: 15px">
                <div style="width: 40px; height: 40px;">
                    <img style="width: 40px; height: 40px;" src="${icono}" />
                </div>
                <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 24px; font-weight: 800; color: #706262">
                    ${titulo}
                </div>
            </div>

            <div style="display: flex; flex-direction: column; gap: 10px; align-items: center">
                <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
                    ${titulo2}
                </div>

                <div style="display: flex; flex-direction: column; gap: 5px; text-align: center; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262; max-height:250px; overflow: auto;">
                    ${mensaje}
                </div>
            </div>
        </div>  
      `,
        width,
        background: "#FFFFFF",
        showCancelButton: false,
        showCloseButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "button-primary-swal",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (ejecutarAccionAlConfirmar && accionConfirmacion) {
            accionConfirmacion();
          }
        }
        if (onAfter) onAfter();
        return result;
      });
  }

  async mostrarMensajeAel3(
    titulo: string = "",
    mensaje: string = "",
    icono: EnumIconos = EnumIconos.exito,
    logo: EnumIconos = EnumIconos.logo,
    options: MensajeAel3Options = {},
  ) {
    const {
      showCancelButton = false,
      confirmButtonText = "Aceptar",
      mostrarConfirmButton = true,
      ejecutarAccionAlConfirmar = false,
      accionConfirmacion,
      accionCancelacion,
      onAfter,
      width = "480px",
      cancelButtonText = "NO",
    } = options;

    return this.swal
      .fire({
        html: `
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
            <div style="width: 150px; height: 84px;">
                <img style="width: 150px; height: 84px;" src="${logo}" />
            </div>

            <div style="display: grid; grid-template-columns: 1fr 3fr; justify-items: center; align-items: center; gap: 15px">
                <div style="width: 52px; height: 52px;">
                    <img style="width: 52px; height: 52px;" src="${icono}" />
                </div>

                <div style="display: flex; flex-direction: column; gap: 10px; align-items: start">
                    <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 16px; font-weight: 800; color: #706262">
                        ${titulo}
                    </div>

                    <div style="text-align: left; font-family: 'Rubik', sans-serif; font-size: 14px; font-weight: 300; color: #706262">
                        ${mensaje}
                    </div>
                </div>
            </div>
        </div>  
      `,
        width,
        background: "#FFFFFF",
        showCancelButton,
        showCloseButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText,
        cancelButtonText,
        showConfirmButton: mostrarConfirmButton,
        customClass: {
          cancelButton: "button-secondary-swal",
          confirmButton: "button-primary-swal",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          if (ejecutarAccionAlConfirmar && accionConfirmacion) {
            accionConfirmacion();
          }
        }

        if (result.isDismissed) {
          if (accionCancelacion) {
            accionCancelacion();
          }
        }

        if (onAfter) onAfter();
        return result;
      });
  }
  async mostrarAdvertenciaCredenciales(
    titulo: string,
    mensaje: string,
    logo: EnumIconos = EnumIconos.logo,
    options: AdvertenciaCredencialesOptions,
  ) {
    const {
      segundosContador = 10,
      confirmButtonText = "Aceptar",
      mensajeConfirmacion,
      width = "700px",
      accionConfirmacion,
      onAfter,
    } = options;

    let intervaloContador: ReturnType<typeof setInterval> | undefined;

    let contadorFinalizado = segundosContador <= 0;
    let confirmacionSeleccionada = false;

    const fechaFinalizacion = Date.now() + Math.max(segundosContador, 0) * 1000;

    const resultado = await this.swal.fire({
      html: `
      <div
        id="modal-advertencia-credenciales"
        style="
          display: flex;
          flex-direction: column;
          width: 100%;
          box-sizing: border-box;
          font-family: 'Rubik', sans-serif;
          color: #625a59;
          text-align: left;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 58px;
            margin: 0 0 12px 0;
            padding: 0;
          "
        >
          <img
            src="${logo}"
            alt="Afiliación en Línea"
            style="
              display: block;
              width: 135px !important;
              height: 58px !important;
              min-width: 135px !important;
              max-width: 135px !important;
              min-height: 58px !important;
              max-height: 58px !important;
              margin: 0 !important;
              padding: 0 !important;
              object-fit: contain;
            "
          />
        </div>

        <div
          style="
            display: grid;
            grid-template-columns: 58px minmax(0, 1fr);
            align-items: center;
            column-gap: 14px;
            width: 100%;
            margin: 0 0 18px 0;
          "
        >
          <div
            id="contador-modal-credenciales"
            aria-live="polite"
            aria-label="Tiempo restante"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 54px;
              height: 54px;
              box-sizing: border-box;
              border: 4px solid #319b80;
              border-radius: 50%;
              color: #a7a7a7;
              font-family: 'Rubik', sans-serif;
              font-size: 26px;
              font-weight: 700;
              line-height: 1;
            "
          >
            ${Math.max(segundosContador, 0)}
          </div>

          <div
            style="
              color: #554c4b;
              font-family: 'Rubik', sans-serif;
              font-size: 22px;
              font-weight: 800;
              line-height: 1.25;
              text-align: left;
            "
          >
            ${titulo}
          </div>
        </div>

        <div
          style="
            width: 100%;
            max-width: 650px;
            padding-left: 72px;
            padding-right: 4px;
            box-sizing: border-box;
            color: #625a59;
            font-family: 'Rubik', sans-serif;
            font-size: 15px;
            font-weight: 300;
            line-height: 1.45;
            text-align: left;
          "
        >
          ${mensaje}
        </div>

        <label
          for="checkbox-modal-credenciales"
          style="
            display: grid;
            grid-template-columns: 20px minmax(0, 1fr);
            align-items: flex-start;
            column-gap: 11px;
            width: 100%;
            max-width: 650px;
            margin-top: 20px;
            padding-left: 72px;
            padding-right: 4px;
            box-sizing: border-box;
            color: #625a59;
            cursor: pointer;
            font-family: 'Rubik', sans-serif;
            font-size: 14px;
            font-weight: 300;
            line-height: 1.42;
            text-align: left;
          "
        >
          <input
            id="checkbox-modal-credenciales"
            type="checkbox"
            style="
              width: 18px;
              height: 18px;
              min-width: 18px;
              margin: 1px 0 0 0;
              padding: 0;
              cursor: pointer;
              accent-color: #008b70;
            "
          />

          <span>
            ${mensajeConfirmacion}
          </span>
        </label>
      </div>
    `,

      width,
      background: "#ffffff",

      showCancelButton: false,
      showCloseButton: false,
      showConfirmButton: true,

      confirmButtonText,

      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: false,

      backdrop: "rgba(0, 0, 0, 0.72)",
      heightAuto: false,

      didOpen: () => {
        const popup = this.swal.getPopup();
        const htmlContainer = this.swal.getHtmlContainer();
        const botonAceptar = this.swal.getConfirmButton();

        const contadorElemento = document.getElementById(
          "contador-modal-credenciales",
        );

        const checkboxElemento = document.getElementById(
          "checkbox-modal-credenciales",
        ) as HTMLInputElement | null;

        if (popup) {
          popup.style.setProperty("width", width, "important");
          popup.style.setProperty(
            "max-width",
            "calc(100vw - 32px)",
            "important",
          );
          popup.style.setProperty("padding", "20px 42px 24px", "important");
          popup.style.setProperty("box-sizing", "border-box", "important");
          popup.style.setProperty("border-radius", "7px", "important");
          popup.style.setProperty("background", "#ffffff", "important");
          popup.style.setProperty("overflow", "visible", "important");
        }

        if (htmlContainer) {
          htmlContainer.style.setProperty("width", "100%", "important");
          htmlContainer.style.setProperty("margin", "0", "important");
          htmlContainer.style.setProperty("padding", "0", "important");
          htmlContainer.style.setProperty("overflow", "visible", "important");
          htmlContainer.style.setProperty(
            "box-sizing",
            "border-box",
            "important",
          );
        }

        const actions = popup?.querySelector(
          ".swal2-actions",
        ) as HTMLElement | null;

        if (actions) {
          actions.style.setProperty("display", "flex", "important");
          actions.style.setProperty("width", "100%", "important");
          actions.style.setProperty("margin", "18px 0 0", "important");
          actions.style.setProperty("padding", "0", "important");
          actions.style.setProperty("justify-content", "center", "important");
          actions.style.setProperty("align-items", "center", "important");
        }

        if (botonAceptar) {
          botonAceptar.disabled = true;

          botonAceptar.style.setProperty("display", "inline-flex", "important");
          botonAceptar.style.setProperty("align-items", "center", "important");
          botonAceptar.style.setProperty(
            "justify-content",
            "center",
            "important",
          );

          botonAceptar.style.setProperty("width", "120px", "important");
          botonAceptar.style.setProperty("min-width", "120px", "important");
          botonAceptar.style.setProperty("max-width", "120px", "important");
          botonAceptar.style.setProperty("height", "36px", "important");
          botonAceptar.style.setProperty("min-height", "36px", "important");

          botonAceptar.style.setProperty("margin", "0 auto", "important");
          botonAceptar.style.setProperty("padding", "8px 24px", "important");

          botonAceptar.style.setProperty("border", "none", "important");
          botonAceptar.style.setProperty("border-radius", "22px", "important");

          botonAceptar.style.setProperty(
            "background-color",
            "#a8d8cc",
            "important",
          );
          botonAceptar.style.setProperty("color", "#ffffff", "important");

          botonAceptar.style.setProperty(
            "font-family",
            "'Rubik', sans-serif",
            "important",
          );
          botonAceptar.style.setProperty("font-size", "15px", "important");
          botonAceptar.style.setProperty("font-weight", "600", "important");

          botonAceptar.style.setProperty("cursor", "not-allowed", "important");
          botonAceptar.style.setProperty("opacity", "1", "important");
          botonAceptar.style.setProperty("box-shadow", "none", "important");
        }

        const actualizarEstadoBoton = (): void => {
          if (!botonAceptar) {
            return;
          }

          const botonHabilitado =
            contadorFinalizado && confirmacionSeleccionada;

          botonAceptar.disabled = !botonHabilitado;

          botonAceptar.setAttribute("aria-disabled", String(!botonHabilitado));

          if (botonHabilitado) {
            botonAceptar.style.setProperty(
              "background-color",
              "#00805d",
              "important",
            );
            botonAceptar.style.setProperty("cursor", "pointer", "important");
            botonAceptar.style.setProperty(
              "box-shadow",
              "0 3px 6px rgba(0, 0, 0, 0.20)",
              "important",
            );
          } else {
            botonAceptar.style.setProperty(
              "background-color",
              "#a8d8cc",
              "important",
            );
            botonAceptar.style.setProperty(
              "cursor",
              "not-allowed",
              "important",
            );
            botonAceptar.style.setProperty("box-shadow", "none", "important");
          }
        };

        const actualizarContador = (): void => {
          const milisegundosRestantes = Math.max(
            0,
            fechaFinalizacion - Date.now(),
          );

          const segundosRestantes = Math.ceil(milisegundosRestantes / 1000);

          if (contadorElemento) {
            contadorElemento.textContent = String(segundosRestantes);
          }

          if (segundosRestantes <= 0) {
            contadorFinalizado = true;

            if (intervaloContador) {
              clearInterval(intervaloContador);
              intervaloContador = undefined;
            }
          }

          actualizarEstadoBoton();
        };

        checkboxElemento?.addEventListener("change", () => {
          confirmacionSeleccionada = checkboxElemento.checked;

          actualizarEstadoBoton();
        });

        actualizarEstadoBoton();
        actualizarContador();

        if (!contadorFinalizado) {
          intervaloContador = setInterval(actualizarContador, 250);
        }
      },

      preConfirm: () => {
        if (!contadorFinalizado || !confirmacionSeleccionada) {
          return false;
        }

        return true;
      },

      willClose: () => {
        if (intervaloContador) {
          clearInterval(intervaloContador);
          intervaloContador = undefined;
        }
      },
    });

    if (resultado.isConfirmed && accionConfirmacion) {
      await accionConfirmacion();
    }

    if (onAfter) {
      onAfter();
    }

    return resultado;
  }

  cerrarMensaje() {
    Swal.close();
  }
}
